var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.getCardNumber)?_c('span',{staticClass:"card_method_number"},[_vm._v(_vm._s(_vm.getCardNumber))]):_vm._e(),_c('img',{staticClass:"image-logo",attrs:{"src":_vm.getCardLogoUrL,"alt":"logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }